import { Box, Stack } from '@dtx-company/design-system/src'
import {
  LOCG_DESIGN_SECTIONS,
  LOCG_DESIGN_SECTIONS_MOBILE,
  LOCG_DESIGN_SECTIONS_SMALL_VARIANT
} from '../../LoggedOutCodeGenerator.constants'
import { LOCG_LOGO_FIRST } from '@app/analytics/src/constants/optimizely'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { forwardRef, useEffect } from 'react'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'

export const CodeDesign = forwardRef<
  HTMLDivElement[],
  { hideBackButton?: boolean; isSmallVariant?: boolean }
>((_props, ref) => {
  const { isMobile } = useScreenSizeBreakpoints()
  const [logoFirst] = useFlowFeature(LOCG_LOGO_FIRST)

  const DesignOptions = isMobile || !logoFirst ? LOCG_DESIGN_SECTIONS_MOBILE : LOCG_DESIGN_SECTIONS
  useEffect(() => {
    fireAnalyticsEvent('LoggedOutGenerator_LOCG_LOGO_FIRST', {
      value: logoFirst
    })
  }, [logoFirst])
  return (
    <>
      <Stack gap={{ xs: 8, md: _props.isSmallVariant ? 6 : 12 }} sx={{ width: '100%' }}>
        {(_props.isSmallVariant ? LOCG_DESIGN_SECTIONS_SMALL_VARIANT : DesignOptions).map(
          ({ id, Component }, i) => (
            <Box
              key={id}
              id={id}
              ref={(el: HTMLDivElement) => {
                if (ref && 'current' in ref) {
                  ref.current = ref.current || []
                  ref.current[i] = el
                }
              }}
              sx={theme => ({
                maxWidth: {
                  md: theme.spacing(136)
                }
              })}
            >
              <Component isSmallVariant={_props.isSmallVariant} />
            </Box>
          )
        )}
      </Stack>
    </>
  )
})

CodeDesign.displayName = 'CodeDesign'
